"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      p {\n        font-size: 0.9em;\n      }\n      th, td {\n        padding: 0.5em 0.8em;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        p {\n          font-size: 0.8em;\n        }\n        th, td {\n          padding: 0.2em 0.6em;\n        }\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  border-spacing: 0;\n  text-align: left;\n  thead {\n    background: ", ";\n  }\n  tbody {\n    background: ", ";\n  }\n  th, td {\n    border: 1px solid ", ";\n  }\n  span, button {\n    margin: 0 .5em;\n  }\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Table = _styledComponents["default"].table(_templateObject(), function (props) {
  return props.width || '100%';
}, function (props) {
  return props.theme.colors.white[700];
}, function (props) {
  return props.theme.colors.white[900];
}, function (props) {
  return props.theme.colors.white[700];
}, function (props) {
  if (props.space === 'tight') {
    return (0, _styledComponents.css)(_templateObject2());
  }

  return (0, _styledComponents.css)(_templateObject3());
});

var _default = Table;
exports["default"] = _default;